import SettingsAndPreferences from './SettingsAndPreferences'

export default SettingsAndPreferences
